import { SubscribeApiResponse } from "./@types";
import MainMenu, { MenuEventType } from "./ui/MainMenu";
import EmailLinkProcessor from "./utilities/EmailLinkProcessor";

const setAvailableScreenHeight = () => {
    const htmlElementComputedStyles = getComputedStyle(document.documentElement);
    const adminBarHeight = htmlElementComputedStyles.getPropertyValue('--wp-admin--admin-bar--height') || "0px";
    const headerElementStyles = getComputedStyle(document.getElementById("masthead")!);
    const headerHeight = headerElementStyles.getPropertyValue('height');

    const availableHeight = window.innerHeight - parseInt(headerHeight, 10) - parseInt(adminBarHeight, 10);

    document.documentElement.style.setProperty('--available-height', availableHeight+"px");
    document.documentElement.style.setProperty('--admin-bar-height', adminBarHeight);
}

const processEmailAddresses = () => {
    // Process email addresses in mailto links
    // https://spencermortensen.com/articles/email-obfuscation/src/text-xor.js
    const emailLinkProcessor = new EmailLinkProcessor(176);
    emailLinkProcessor.decode('.email');

    console.log("enquiries@themoutdoors.co.uk : "+emailLinkProcessor.encode("enquiries@themoutdoors.co.uk"));
    console.log("info@themoutdoors.co.uk : "+emailLinkProcessor.encode("info@themoutdoors.co.uk"));
    console.log("privacy@themoutdoors.co.uk : "+emailLinkProcessor.encode("privacy@themoutdoors.co.uk"));
    console.log("sales@themoutdoors.co.uk : "+emailLinkProcessor.encode("sales@themoutdoors.co.uk"));
    console.log("contact@themoutdoors.co.uk : "+emailLinkProcessor.encode("contact@themoutdoors.co.uk"));
}

const createNavMenu = () => {
    const menuIconEl = document.querySelector('#main-menu-icon') as HTMLElement;
    const menuNavEl = document.querySelector('#main-menu nav') as HTMLElement;
    const mainMenuEl = document.querySelector('#main-menu') as HTMLElement;

    if (menuIconEl && menuNavEl && mainMenuEl) {
        const menu = new MainMenu(
            document.querySelector('#main-menu-icon') as HTMLElement,
            document.querySelector('#main-menu nav') as HTMLElement,
            document.querySelector('#main-menu') as HTMLElement,
        );
        menu.on(MenuEventType.Open, () => {
            document.body.querySelector('.site-header .them-outdoors-logo')?.classList.add('hidden');
            document.body.querySelector('.site-header .account-options-container menu')?.classList.add('hidden');
            document.body.style.overflow = "hidden";
        });
        menu.on(MenuEventType.Close, () => {
            document.body.querySelector('.site-header .them-outdoors-logo')?.classList.remove('hidden');
            document.body.querySelector('.site-header .account-options-container menu')?.classList.remove('hidden');
            document.body.style.overflow = "auto";
        });
    }

}

const disableSubmitButton = () => {
    console.log("disableSubmitButton()");
    const submitButton = document.querySelector('.site-footer .signup-form button') as HTMLButtonElement;
    submitButton.setAttribute('disabled', 'true');
}

const updateSubmitButtonState = (state:"submitting"|"submitted") => {
    const submitButton = document.querySelector('.site-footer .signup-form button') as HTMLButtonElement;
    switch(state) {
        case "submitting":
            submitButton.classList.add('submitting');
            submitButton.innerHTML = `<span class="loader"></span>`;
            break;

        case "submitted":
            submitButton.classList.remove('submitting');
            submitButton.classList.add('submitted');
            submitButton.innerHTML = `<div class="submitted"><i class="fa-duotone fa-check fa-beat"></i></div>`;
            break;
    }

}

async function submitFormData(email:string):Promise<SubscribeApiResponse> {
    console.log("submitFormData()");
    const res = await fetch(`/api/newsletter/subscribe`, {
        body: JSON.stringify({
            email: email
        }),
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'PUT',
      })

    return await res.json();
}

async function handleSignupFormSubmit(email:string):Promise<SubscribeApiResponse> {
    console.log("handleSignupFormSubmit()");
    disableSubmitButton();
    updateSubmitButtonState("submitting");
    return submitFormData(email);
}

const setupSignupForm = () => {
    const form = document.querySelector('.site-footer .signup-form') as HTMLFormElement;
    if (form) {
        form.addEventListener('submit', async (event) => {
            console.log("FORM SUBMIT");
            event.preventDefault();
            const response = await handleSignupFormSubmit( ( form.querySelector('[name="email"]') as HTMLInputElement ).value );

            switch(response.statuscode) {
                case 200:
                    console.log("Operation success");
                    updateSubmitButtonState("submitted");
                    break;

                case 502:
                    console.log("Bad gateway");
                    break;

                default:
                    console.log('DuNO');
                    console.log(response.statuscode);
            }
        });
    }
}

const run = () => {

    // Store the available screen height (minus WP Admin bar height and minus #masthead element height) in a CSS variable
    setAvailableScreenHeight();
    window.addEventListener('resize', setAvailableScreenHeight);

    // Process mailto email adddresses
    processEmailAddresses();

    // Set up main navigation
    createNavMenu();

    // Handle signup form submission
    setupSignupForm();

}

run();